import React from 'react';
import { useTranslation } from 'react-i18next';
import { useCookieConsent } from './CookieConsentContext';

export default function ConsentGatedEmbed({ src, title, category, className, placeholderText }) {
	const { t } = useTranslation();
	const { consent, setShowPreferences } = useCookieConsent();

	if (consent[category]) {
		return (
			<iframe
				className={className}
				title={title}
				src={src}
				loading="lazy"
			/>
		);
	}

	return (
		<div className="consent-placeholder" style={{
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'center',
			justifyContent: 'center',
			gap: '16px',
			padding: '40px 24px',
			background: 'rgba(255,255,255,0.03)',
			border: '1px solid rgba(255,255,255,0.08)',
			borderRadius: '16px',
			minHeight: '300px',
			textAlign: 'center',
		}}>
			<svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.4)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
				<path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/>
				<circle cx="12" cy="10" r="3"/>
			</svg>
			<p style={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.9rem', maxWidth: '320px', lineHeight: 1.6, margin: 0 }}>
				{placeholderText || t('contact.mapConsent')}
			</p>
			<button
				onClick={() => setShowPreferences(true)}
				style={{
					background: 'rgba(20, 167, 208, 0.15)',
					color: '#14a7d0',
					border: '1px solid rgba(20, 167, 208, 0.3)',
					padding: '10px 20px',
					borderRadius: '8px',
					cursor: 'pointer',
					fontSize: '0.85rem',
					fontWeight: 500,
					transition: 'all 0.2s',
				}}
				onMouseEnter={(e) => {
					e.target.style.background = 'rgba(20, 167, 208, 0.25)';
				}}
				onMouseLeave={(e) => {
					e.target.style.background = 'rgba(20, 167, 208, 0.15)';
				}}
			>
				{t('cookies.managePreferences')}
			</button>
		</div>
	);
}
